<template>
  <a-page
    :id="app_id"
    :image_source="image_source"
    :image_height="image_height"
  >
    <template v-slot:header_options>
      <v-select
        v-model="calendar_year"
        :items="available_years.reverse()"
        mandatory
        rounded
        outlined
        dense
        class="mt-8"
        style="max-width: 120px;"
      ></v-select>
    </template>
    <v-row>
      <v-col cols="3">
        <calendar-card-list></calendar-card-list>
      </v-col>
      <v-col cols="9">
        <v-card>
          <v-toolbar color="white" light flat>
            <v-toolbar-title>
              {{ $t("events_of") }} <b>{{ calendar_name }} </b>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div>
              <v-tabs
                color="deep-purple accent-4"
                right
                v-model="tab"
                class="calendar_events_tabs"
              >
                <v-tab key="events">{{ $t("events") }}</v-tab>
                <v-tab key="hotels">{{ $t("subscribed_hotels") }}</v-tab>
              </v-tabs>
            </div>
          </v-toolbar>
          <!-- <v-divider></v-divider> -->
          <v-tabs-items v-model="tab">
            <v-tab-item key="events">
              <v-card-text>
                <calendar-events></calendar-events>
              </v-card-text>
            </v-tab-item>
            <v-tab-item key="hotels">
              <v-card-text>
                <calendar-subscribed-hotels
                  :calendar="calendar_selected"
                  @getCalendars="getCalendars"
                ></calendar-subscribed-hotels>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </a-page>
</template>

<script>
import aPage from "@/components/aPage";
import CalendarCardList from "@/components/calendar/CalendarCardList.vue";
import CalendarEvents from "@/components/calendar/CalendarEvents.vue";
import CalendarSubscribedHotels from "@/components/calendar/CalendarSubscribedHotels.vue";
import * as Utils from "@/utils.js";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "EventManagement",
  components: {
    aPage,
    CalendarEvents,
    CalendarSubscribedHotels,
    CalendarCardList
  },
  data: () => ({
    app_id: "calendar-app",
    image_source: "/img/header-2.jpg", // Mandatory path
    image_height: 140, // Mandatory number
    tab: null
  }),
  computed: {
    ready() {
      return this.calendar_year && this.current_hotel && this.current_hotel.id;
    },
    calendar_name() {
      return this.calendar_selected ? this.calendar_selected.name : "";
    },
    calendar_year: {
      get() {
        return this.calendar_store.calendar_year;
      },
      set(value) {
        this.$store.dispatch("setCalendarYear", value);
      }
    },
    visible_calendars: {
      get() {
        return this.calendar_store.visible_calendars;
      },
      set(value) {
        this.$store.dispatch("setVisibleCalendars", value);
      }
    },
    ...mapState({
      calendar_store: state => state.calendar,
      calendar_selected: state => state.calendar.calendar_selected
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      available_years: "getHotelAvailableYears",
      getHotelCalendars: "getHotelCalendars"
    })
  },
  methods: {
    getCalendars() {
      this.$store
        .dispatch("getCalendars", {})
        .then(() => {
          this.visible_calendars = this.calendar_store.calendars;
        })
        .catch(() => {
          Utils.showError(this, "something_went_wrong");
        });

      this.getCalendarEvents();
    },
    getCalendarEvents() {
      if (!this.calendar_selected || this.calendar_selected.id == null) {
        return;
      }
      this.$store
        .dispatch("getCalendarEvents", {
          year: this.calendar_year,
          calendar_id: this.calendar_selected.id
        })
        .catch(() => {
          Utils.showError(this, "something_went_wrong");
        });
    }
  },
  watch: {
    ready(v) {
      if (v) {
        this.getCalendars();
      }
    },
    calendar_year() {
      if (this.ready) {
        this.getCalendars();
        this.getCalendarEvents();
      }
    },
    calendar_selected(calendar) {
      if (calendar) {
        this.getCalendarEvents();
      }
    }
  },
  mounted() {
    if (this.calendar_year !== null && this.ready) {
      this.getCalendars();
    } else {
      this.calendar_year = Vue.moment()
        .year()
        .toString();
    }
  }
};
</script>
